import { Flex, Text } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { AppData, Token } from './types';
import { Info } from '@Components/Common/Info';
import { AppForSa } from '@Types/administrator';

const ExchangeServer = ({ appData }: { appData: AppData }) => {
  const { t } = useTranslation('administration');
  return (
    <Flex gap="8px" align="center">
      <Text wordBreak="break-all">{appData.email}</Text>
      <Info
        variant="solid"
        content={t('administration.sa.table.email.exchangeServerTip')}
      />
    </Flex>
  );
};

// const EmailAndAppId = ({
//   appData,
//   appId,
// }: {
//   appData: AppData;
//   appId: string;
// }) => {
//   const { t } = useTranslation('administration');
//
//   return (
//     <Flex direction="column">
//       <Text wordBreak="break-all">{appData.email}</Text>
//       <TextLabel>
//         <strong>{t('administration.sa.table.email.appId')}:&nbsp;</strong>
//         {appId}
//       </TextLabel>
//     </Flex>
//   );
// };

const SATableEmail = ({
  appData,
  // token,
}: {
  appData: AppData;
  token: Token;
}) => {
  if (appData.app === AppForSa.ExchangeServer) {
    return <ExchangeServer appData={appData} />;
  }
  // if (
  //   appData.app === AppForSa.SharePoint ||
  //   appData.app === AppForSa.OneDrive ||
  //   appData.app === AppForSa.Teams
  // ) {
  //   return <EmailAndAppId appData={appData} appId={token.appId} />;
  // }

  return <Text wordBreak="break-all">{appData.email}</Text>;
};

export default SATableEmail;
